import { render, staticRenderFns } from "./ClientsPortfolioInfoForm.vue?vue&type=template&id=721efbc3"
import script from "./ClientsPortfolioInfoForm.vue?vue&type=script&lang=js"
export * from "./ClientsPortfolioInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports